<div class="w-full md:h-[calc(100vh-100px-var(--bottom-bar-height,0px))] flex flex-col justify-between select-none md:overflow-hidden space-y-3">
  <div class="w-full flex-1 flex flex-col min-h-0 space-y-3 overflow-hidden">
    <!-- CONTROLS ROW: Date Range Filter & Add Missing Artist Button -->
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 shrink-0">
      <!-- Left: Date Range Filter Picker -->
      <div class="flex items-center gap-2">
        <app-date-range-picker
          [activePresetId]="pickerPresetId()"
          [startDate]="pickerStartDate()"
          [endDate]="pickerEndDate()"
          [loading]="isDateRangeLoading()"
          (rangeChange)="onDateRangeChange($event)"
        />
      </div>

      <!-- Right: Action Buttons -->
      <div class="flex items-center gap-2.5">
        <app-table-customizer
          [(columns)]="customizableColumns"
          [(kpiCards)]="customizableKpis"
          [(isOpen)]="isCustomizePanelOpen"
          [activeView]="activeView()"
          [views]="views()"
          [isAuthenticated]="isAuthenticated()"
          [isDirty]="isLayoutDirty()"
          [initialNamingDraft]="pendingSaveDraftName()"
          [periodOptions]="periodOptions"
          [activePeriodId]="pickerPresetId()"
          (selectView)="onSelectView($event)"
          (renameView)="onRenameView($event)"
          (deleteView)="onDeleteView($event)"
          (saveView)="onSaveView($event)"
          (resetLayout)="onResetLayout()"
          (saveRequiresAuth)="onSaveRequiresAuth($event)"
          (namingDraftConsumed)="pendingSaveDraftName.set(null)"
          (periodChange)="onPeriodSelect($event)"
        />

        <app-button
          variant="outlined"
          size="small"
          label="Add Missing Artist"
          (btnClick)="openSuggestionModal()"
        >
          <svg
            left-icon
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </app-button>
      </div>
    </div>

    <!-- KPI CARDS + TABLE & DRAWER ROW -->
    <div
      class="flex-1 min-h-0 flex flex-row items-stretch overflow-hidden"
      [class.gap-3]="layoutService.isSidebarOpen()"
    >
      <!-- LEFT COLUMN: KPI CARDS + TABLE + PAGINATION -->
      <div class="flex-1 min-w-0 h-full flex flex-col justify-between space-y-3 overflow-hidden">
        <div class="w-full flex-1 min-w-0 flex flex-col min-h-0 space-y-3 overflow-hidden">
          <!-- KPI CARDS GRID (Customizable) -->
          @if (kpisLoaded()) {
            @if (visibleKpiCount() > 0) {
              <div class="grid gap-3 shrink-0" [ngClass]="kpiGridClass()">
                @if (isKpiVisible('breakouts')) {
                  <app-kpi-card
                    label="Breakouts"
                    [value]="kpiBreakoutCount()"
                    suffix=" Artists"
                    [caption]="breakoutGrowthCaption()"
                    [loading]="isDateRangeLoading()"
                    [animationDelayMs]="0"
                    infoTooltip="Emerging artists (≤ 100k Spotify monthly listeners) with positive listener growth over the selected timeframe."
                  >
                    <svg
                      icon
                      width="20"
                      height="17"
                      viewBox="0 0 20 17"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.4 1.2C2.4 0.53625 1.86375 0 1.2 0C0.53625 0 0 0.53625 0 1.2V13.8C0 15.4575 1.3425 16.8 3 16.8H18C18.6637 16.8 19.2 16.2637 19.2 15.6C19.2 14.9362 18.6637 14.4 18 14.4H3C2.67 14.4 2.4 14.13 2.4 13.8V1.2ZM17.6475 4.4475C18.1162 3.97875 18.1162 3.2175 17.6475 2.74875C17.1787 2.28 16.4175 2.28 15.9487 2.74875L12 6.70125L9.8475 4.5525C9.37875 4.08375 8.6175 4.08375 8.14875 4.5525L4.54875 8.1525C4.08 8.62125 4.08 9.3825 4.54875 9.85125C5.0175 10.32 5.77875 10.32 6.2475 9.85125L9 7.09875L11.1525 9.25125C11.6212 9.72 12.3825 9.72 12.8512 9.25125L17.6512 4.45125L17.6475 4.4475Z"
                      />
                    </svg>
                  </app-kpi-card>
                }

                @if (isKpiVisible('ifpi')) {
                  <app-kpi-card
                    label="Made it to IFPI Charts"
                    [value]="ifpiPercentageValue()"
                    suffix="%"
                    [caption]="breadthTimeframeDisplayLabel()"
                    [loading]="isDateRangeLoading()"
                    [animationDelayMs]="40"
                  >
                    <svg
                      icon
                      width="21"
                      height="21"
                      viewBox="0 0 640 640"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M353.8 118.1L330.2 70.3C326.3 62 314.1 61.7 309.8 70.3L286.2 118.1L233.9 125.6C224.6 127 220.6 138.5 227.5 145.4L265.5 182.4L256.5 234.5C255.1 243.8 264.7 251 273.3 246.7L320.2 221.9L366.8 246.3C375.4 250.6 385.1 243.4 383.6 234.1L374.6 182L412.6 145.4C419.4 138.6 415.5 127.1 406.2 125.6L353.9 118.1zM288 320C261.5 320 240 341.5 240 368L240 528C240 554.5 261.5 576 288 576L352 576C378.5 576 400 554.5 400 528L400 368C400 341.5 378.5 320 352 320L288 320zM80 384C53.5 384 32 405.5 32 432L32 528C32 554.5 53.5 576 80 576L144 576C170.5 576 192 554.5 192 528L192 432C192 405.5 170.5 384 144 384L80 384zM448 496L448 528C448 554.5 469.5 576 496 576L560 576C586.5 576 608 554.5 608 528L608 496C608 469.5 586.5 448 560 448L496 448C469.5 448 448 469.5 448 496z"
                      />
                    </svg>
                  </app-kpi-card>
                }

                @if (isKpiVisible('active')) {
                  <app-kpi-card
                    label="Most Active Artists"
                    [value]="kpiActiveCount()"
                    [caption]="breadthTimeframeDisplayLabel()"
                    [loading]="isDateRangeLoading()"
                    [animationDelayMs]="80"
                  >
                    <svg
                      icon
                      width="17"
                      height="21"
                      viewBox="0 0 17 21"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7054 0.229383C13.1517 0.551883 13.3167 1.13688 13.1142 1.64688L10.1742 9.00063H15.6004C16.1067 9.00063 16.5567 9.31563 16.7292 9.79188C16.9017 10.2681 16.7554 10.8006 16.3692 11.1231L5.56916 20.1231C5.14541 20.4756 4.54166 20.4944 4.09541 20.1719C3.64916 19.8494 3.48416 19.2644 3.68666 18.7544L6.62666 11.4006H1.20041C0.694159 11.4006 0.244159 11.0856 0.0716588 10.6094C-0.100841 10.1331 0.0454087 9.60063 0.431659 9.27813L11.2317 0.278133C11.6554 -0.0743672 12.2592 -0.0931174 12.7054 0.229383Z"
                      />
                    </svg>
                  </app-kpi-card>
                }
              </div>
            }
          } @else {
            @if (visibleKpiCount() > 0) {
              <div class="grid gap-3 shrink-0" [ngClass]="kpiGridClass()">
                @for (kpi of visibleKpis(); track kpi.id) {
                  <div
                    class="bg-card-bg-default rounded-md h-[110px] animate-pulse"
                  ></div>
                }
              </div>
            }
          }

          <!-- 2. FILTERS & SEARCH ROW: Audience, Career Stage & Search artists -->
          <div
            class="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 shrink-0"
          >
            <!-- Left: Audience & Career Stage Dropdowns -->
            <div class="flex items-center gap-2 flex-wrap">
              <app-dropdown
                variant="naked-secondary"
                size="medium"
                [multiSelect]="true"
                label="Audience"
                [badge]="selectedAudienceFilters().length"
                [options]="audienceOptions"
                [selectedValues]="selectedAudienceFilters()"
                [isOpen]="activeFilterDropdown() === 'audience'"
                (isOpenChange)="onFilterDropdownOpenChange('audience', $event)"
                menuClassName="min-w-[280px]"
                [className]="selectedAudienceFilters().length ? 'text-text-primary! font-bold' : ''"
                (selectedValuesChange)="onAudienceFiltersChange($any($event))"
              />

              <app-dropdown
                variant="naked-secondary"
                size="medium"
                [multiSelect]="true"
                label="Career Stage"
                [badge]="selectedCareerFilters().length"
                [options]="careerOptions"
                [selectedValues]="selectedCareerFilters()"
                [isOpen]="activeFilterDropdown() === 'career'"
                (isOpenChange)="onFilterDropdownOpenChange('career', $event)"
                menuClassName="min-w-[280px]"
                [className]="selectedCareerFilters().length ? 'text-text-primary! font-bold' : ''"
                (selectedValuesChange)="onCareerFiltersChange($any($event))"
              />

              @if (hasActiveFilters()) {
                <button
                  type="button"
                  (click)="clearAllFilters()"
                  class="text-xs font-semibold text-text-half-dimmed hover:text-text-primary transition-colors cursor-pointer px-2.5 py-1.5 rounded-sm hover:bg-card-bg-hover"
                >
                  Reset filters
                </button>
              }
            </div>

            <!-- Right: Search Artist by Name -->
            <div class="w-full sm:w-64 md:w-72 shrink-0">
              <app-search-bar
                placeholder="Search artists..."
                [value]="searchQuery()"
                [clearable]="true"
                (valueChange)="onSearchChange($event)"
              />
            </div>
          </div>

          <!-- 3. TABLE CONTAINER & PAGINATION -->
          <div
            class="h-[calc(100vh-6rem)] md:h-auto md:flex-1 md:min-h-0 flex flex-col overflow-hidden"
          >
            <app-chart-table
              [data]="sortedFilteredArtists()"
              [columns]="displayedColumns()"
              [loading]="loading()"
              [sortKey]="sortOption()"
              [sortDirection]="sortDirection()"
              [(currentPage)]="currentPage"
              [(pageSize)]="pageSize"
              minTableWidth="100%"
              itemCountLabel="Artists"
              emptyMessage="No artist data matches your criteria."
              [customCellTemplate]="customCell"
              (sortChange)="handleSort($any($event))"
              (rowClick)="openArtistDrawer($event.item.artist, $event.event)"
            />
          </div>

          <!-- Custom cell template for Artist Rankings table -->
          <ng-template #customCell let-row let-col="column">
            @switch (col.id) {
              @case ('name') {
                <div class="flex items-center gap-3 min-w-0">
                  <img
                    [src]="row.artist.imageUrl || defaultArtistPlaceholder"
                    [alt]="row.artist.name"
                    class="w-9 h-9 rounded-full object-cover border border-card-border-border shrink-0"
                  />
                  <div class="min-w-0 flex-1">
                    <div class="font-bold text-text-primary leading-snug truncate">
                      <ng-container
                        *ngTemplateOutlet="highlightTpl; context: { text: row.artist.name }"
                      />
                    </div>
                    <div class="text-xs text-text-half-dimmed font-normal truncate">
                      <ng-container
                        *ngTemplateOutlet="
                          highlightTpl;
                          context: { text: row.artist.genres?.[0] || '' }
                        "
                      />
                    </div>
                  </div>
                </div>
              }
              @case ('totalSongs') {
                <div class="text-center">
                  <span
                    (click)="openReleasesModal(row.artist, $event)"
                    class="hover:underline hover:text-white transition-colors cursor-pointer font-semibold inline-block px-2 py-0.5 rounded hover:bg-card-bg-hover/60"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        highlightTpl;
                        context: { text: '' + (row.artist.totalSongs || 0) }
                      "
                    />
                  </span>
                </div>
              }
              @case ('rank') {
                <span class="font-bold text-text-primary tabular-nums">
                  <ng-container
                    *ngTemplateOutlet="
                      highlightTpl;
                      context: { text: '' + (row.artist.rank || '-'), allowHashFallback: true }
                    "
                  />
                </span>
              }
              @case ('globalRank') {
                <span class="font-semibold text-text-half-dimmed tabular-nums">
                  {{ row.artist.globalRank || '-' }}
                </span>
              }
              @case ('hypeScore') {
                <div class="flex items-center justify-center gap-2.5">
                  <span class="w-7 text-right font-bold text-text-primary tabular-nums">
                    {{ row.artist.hypeScore ?? '-' }}
                  </span>
                  <div class="h-1.5 w-16 shrink-0 overflow-hidden rounded-full bg-text-inverted-primary">
                    <div
                      class="h-full rounded-full bg-text-brand"
                      [style.width.%]="row.artist.hypeScore ?? 0"
                    ></div>
                  </div>
                  <span
                    class="w-10 text-left text-xs font-semibold tabular-nums"
                    [class]="scoreChangeClass(row.artist.hypeScoreChange)"
                    title="Change over the last 7 days"
                  >
                    {{ formatScoreChange(row.artist.hypeScoreChange) }}
                  </span>
                </div>
              }
              @case ('chartedSongs') {
                <div class="text-center">
                  <ng-container
                    *ngTemplateOutlet="
                      highlightTpl;
                      context: {
                        text: '' + (row.artist.chartedSongs || row.artist.rank || '-'),
                        allowHashFallback: true,
                      }
                    "
                  />
                </div>
              }
              @default {
                <div
                  [class.text-center]="col.align === 'center'"
                  [class.text-right]="col.align === 'right'"
                >
                  <ng-container
                    *ngTemplateOutlet="highlightTpl; context: { text: getCellDisplay(row, col) }"
                  />
                </div>
              }
            }
          </ng-template>

          <ng-template #highlightTpl let-text="text" let-allowHashFallback="allowHashFallback">
            <!-- prettier-ignore -->
            @for (part of getHighlightParts(text, searchQuery(), allowHashFallback); track $index) {@if (part.match) {<span class="bg-[#4F39F6] text-white p-0 m-0 rounded-none inline" style="background-color: #4f39f6; color: #ffffff; padding: 0; margin: 0; border-radius: 2px;">{{ part.text }}</span>} @else {{{ part.text }}}}
          </ng-template>
        </div>
      </div>

      <!-- Drawer stays mounted inside row, takes exact height of left column (KPI Cards + Table + Pagination) -->
      <div
        class="relative h-full shrink-0 transition-all duration-300 ease-in-out max-md:w-0!"
        [class.w-[380px]]="layoutService.isSidebarOpen()"
        [class.w-0]="!layoutService.isSidebarOpen()"
        [class.opacity-100]="layoutService.isSidebarOpen()"
        [class.opacity-0]="!layoutService.isSidebarOpen()"
        [class.pointer-events-none]="!layoutService.isSidebarOpen()"
      >
        <app-artist-profile-preview-drawer
          #artistPreview
          mode="inline"
          (sidebarOpenChange)="layoutService.isSidebarOpen.set($event)"
        />
      </div>
    </div>
  </div>

  <!-- Bottom ticker bar: scoped to this page (not the global app shell) so it only
       exists while this page is mounted; see ngOnInit/ngOnDestroy for the matching
       --bottom-bar-height reservation above. -->
  <app-dashboard-ticker [items]="dashboardTickerService.items()" [loading]="dashboardTickerService.loading()" />

  <!-- SUGGESTION MODAL -->
  @if (showSuggestionModal()) {
    <div
      class="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-100 p-4"
    >
      <div
        class="bg-card-bg-default border border-card-border-border rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
      >
        <div class="p-6 border-b border-card-border-border flex items-center justify-between">
          <h3 class="text-xl font-bold text-text-primary uppercase tracking-tight">
            Suggest Missing Artist
          </h3>
          <button
            (click)="closeSuggestionModal()"
            class="text-text-half-dimmed hover:text-text-primary transition-colors p-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div class="p-8 space-y-6">
          @if (suggestionSuccess()) {
            <div
              class="p-4 bg-emerald-500/10 border border-emerald-500/40 rounded-xl text-text-success text-sm text-center"
            >
              <p class="font-bold text-lg mb-1">Success!</p>
              <p>We'll review your suggestion shortly.</p>
            </div>
          } @else {
            @if (suggestionError()) {
              <div
                class="p-4 bg-rose-500/10 border border-rose-500/40 rounded-xl text-text-destructive text-sm font-bold"
              >
                {{ suggestionError() }}
              </div>
            }
            <div class="space-y-5">
              <div>
                <label
                  class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                  >Artist Name *</label
                >
                <input
                  type="text"
                  [(ngModel)]="suggestionForm().name"
                  class="w-full px-4 py-3 border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                  placeholder="e.g. SNIK"
                />
              </div>

              <div class="rounded-xl border border-card-border-border p-4 space-y-4">
                <p class="text-xs font-semibold text-text-half-dimmed uppercase tracking-wider">
                  Official Links
                </p>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label
                      class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                      >Spotify</label
                    >
                    <input
                      type="text"
                      [(ngModel)]="suggestionForm().spotifyUrl"
                      class="w-full px-4 py-3 bg-card-bg-default border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                      placeholder="https://open.spotify.com/..."
                    />
                  </div>
                  <div>
                    <label
                      class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                      >YouTube</label
                    >
                    <input
                      type="text"
                      [(ngModel)]="suggestionForm().youtubeUrl"
                      class="w-full px-4 py-3 bg-card-bg-default border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                      placeholder="https://youtube.com/..."
                    />
                  </div>
                  <div>
                    <label
                      class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                      >Instagram</label
                    >
                    <input
                      type="text"
                      [(ngModel)]="suggestionForm().instagramHandle"
                      class="w-full px-4 py-3 bg-card-bg-default border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                      placeholder="@artist"
                    />
                  </div>
                  <div>
                    <label
                      class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                      >TikTok</label
                    >
                    <input
                      type="text"
                      [(ngModel)]="suggestionForm().tiktokUrl"
                      class="w-full px-4 py-3 bg-card-bg-default border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                      placeholder="https://tiktok.com/@artist"
                    />
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                    >Your Email (Optional)</label
                  >
                  <input
                    type="email"
                    [(ngModel)]="suggestionForm().suggestedByEmail"
                    class="w-full px-4 py-3 border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                    placeholder="name@email.com"
                  />
                </div>
                <div>
                  <label
                    class="block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider mb-2"
                    >Additional Info</label
                  >
                  <input
                    type="text"
                    [(ngModel)]="suggestionForm().additionalInfo"
                    class="w-full px-4 py-3 border border-input-field-border-default rounded-xl text-text-primary focus:border-input-field-border-hover outline-none transition-all"
                    placeholder="Optional notes"
                  />
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 pt-4">
                <app-button
                  variant="outlined"
                  size="medium"
                  label="Cancel"
                  className="w-full justify-center"
                  (btnClick)="closeSuggestionModal()"
                ></app-button>
                <app-button
                  variant="primary"
                  size="medium"
                  [label]="suggestionSubmitting() ? 'Submitting...' : 'Submit'"
                  [disabled]="suggestionSubmitting() || !suggestionForm().name.trim()"
                  className="w-full justify-center"
                  (btnClick)="submitSuggestion()"
                ></app-button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Total Releases Popup Modal -->
  @if (showReleasesModal() && selectedArtistForReleases()) {
    <div
      class="fixed inset-0 bg-black/85 backdrop-blur-md z-300 flex items-center justify-center p-4"
      (click)="closeReleasesModal()"
    >
      <div
        class="w-full max-w-3xl bg-card-bg-default text-text-primary rounded-md px-3 pb-3 pt-5 shadow-2xl space-y-4"
        (click)="$event.stopPropagation()"
      >
        <!-- Modal Header -->
        <div class="flex items-center justify-between">
          <h2 class="text-lg md:text-xl font-bold tracking-tight text-text-half-dimmed">
            Total Releases /
            <span class="text-text-primary">{{ selectedArtistForReleases()?.name }}</span>
          </h2>
          <button
            type="button"
            (click)="closeReleasesModal()"
            class="w-8 h-8 rounded-full flex items-center justify-center text-text-half-dimmed hover:text-text-primary hover:bg-card-bg-hover transition-colors cursor-pointer"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.05031 0.355312C1.58156 -0.113438 0.820313 -0.113438 0.351562 0.355312C-0.117188 0.824062 -0.117188 1.58531 0.351562 2.05406L5.50406 7.20281L0.355312 12.3553C-0.113438 12.8241 -0.113438 13.5853 0.355312 14.0541C0.824062 14.5228 1.58531 14.5228 2.05406 14.0541L7.20281 8.90156L12.3553 14.0503C12.8241 14.5191 13.5853 14.5191 14.0541 14.0503C14.5228 13.5816 14.5228 12.8203 14.0541 12.3516L8.90156 7.20281L14.0503 2.05031C14.5191 1.58156 14.5191 0.820313 14.0503 0.351562C13.5816 -0.117188 12.8203 -0.117188 12.3516 0.351562L7.20281 5.50406L2.05031 0.355312Z"
              />
            </svg>
          </button>
        </div>

        <!-- Controls Row: Tabs & Sort Dropdown -->
        <div
          class="flex items-center justify-between border-b border-card-border-border pb-2 text-sm"
        >
          <!-- Tabs -->
          <div class="flex items-center gap-6 font-medium">
            <button
              type="button"
              (click)="selectReleasesTab('all')"
              [class]="
                releasesTab() === 'all'
                  ? 'text-text-primary border-b-2 border-text-primary pb-2.5 font-semibold -mb-2 cursor-pointer'
                  : 'text-text-dimmed hover:text-text-primary pb-2.5 -mb-2 transition-colors cursor-pointer'
              "
            >
              All ({{ releasesAll().length }})
            </button>

            <button
              type="button"
              (click)="selectReleasesTab('solo')"
              [class]="
                releasesTab() === 'solo'
                  ? 'text-text-primary border-b-2 border-text-primary pb-2.5 font-semibold -mb-2 cursor-pointer'
                  : 'text-text-dimmed hover:text-text-primary pb-2.5 -mb-2 transition-colors cursor-pointer'
              "
            >
              Solo ({{ releasesSolo().length }})
            </button>

            <button
              type="button"
              (click)="selectReleasesTab('featured')"
              [class]="
                releasesTab() === 'featured'
                  ? 'text-text-primary border-b-2 border-text-primary pb-2.5 font-semibold -mb-2 cursor-pointer'
                  : 'text-text-dimmed hover:text-text-primary pb-2.5 -mb-2 transition-colors cursor-pointer'
              "
            >
              Featured ({{ releasesFeatured().length }})
            </button>
          </div>

          <!-- Sort Dropdown using <app-dropdown> -->
          <div>
            <app-dropdown
              variant="naked-primary"
              size="small"
              align="right"
              [options]="releasesSortOptions"
              [label]="'Sort by ' + (releasesSort() === 'newest' ? 'Newest' : 'More plays')"
              (selectOption)="onReleasesSortSelect($event)"
            ></app-dropdown>
          </div>
        </div>

        <!-- Release Items List -->
        <div class="max-h-[380px] overflow-y-auto pr-1 space-y-2.5 custom-scrollbar">
          @if (loadingReleases()) {
            <div class="text-center py-12 text-text-half-dimmed">
              <div
                class="inline-block w-7 h-7 border-2 border-text-primary/20 border-t-text-primary rounded-full animate-spin"
              ></div>
              <p class="mt-2 text-xs">Loading releases...</p>
            </div>
          } @else if (currentTabReleases().length === 0) {
            <div class="text-center py-12 text-text-half-dimmed text-sm">
              No releases found for this category.
            </div>
          } @else {
            @for (rel of currentTabReleases(); track rel.id) {
              <div
                class="flex items-center justify-between hover:bg-card-bg-hover border border-card-border-border rounded-md p-3 transition-colors"
              >
                <div class="flex items-center gap-3 min-w-0">
                  <img
                    [src]="
                      rel.imageUrl ||
                      selectedArtistForReleases()?.imageUrl ||
                      defaultArtistPlaceholder
                    "
                    [alt]="rel.title"
                    class="w-12 h-12 rounded-sm object-cover shrink-0"
                  />
                  <div class="min-w-0">
                    <div class="font-bold text-text-primary text-sm truncate">{{ rel.title }}</div>
                    <div class="text-xs text-text-half-dimmed mt-0.5">
                      {{ formatRelativeReleaseDate(rel.releaseDate) }}
                    </div>
                  </div>
                </div>

                <div class="shrink-0 ml-3">
                  <app-badge
                    variant="neutral"
                    size="tiny"
                    [label]="rel.streams != null ? (rel.streams | number) + ' Plays' : '- Plays'"
                  ></app-badge>
                </div>
              </div>
            }
          }
        </div>

        <!-- Modal Footer using <app-button> -->
        <div class="flex items-center justify-end gap-3 pt-3 border-t border-card-border-border">
          <app-button
            variant="outlined"
            size="medium"
            label="Go back"
            (btnClick)="closeReleasesModal()"
          ></app-button>

          <app-button
            variant="primary"
            size="medium"
            label="View Artist Profile"
            (btnClick)="viewArtistProfileFromModal($event)"
          ></app-button>
        </div>
      </div>
    </div>
  }

  <app-sign-in-modal
    [isOpen]="isSignInModalOpen()"
    (success)="onSignInSuccess()"
    (closed)="onSignInModalClosed()"
  />
</div>
